// src/utils/markerHelper.js
import L from 'leaflet';
import tafelIconUrl from '../assets/tafel.png';

export const tafelIcon = L.divIcon({
  className: '',
  iconSize: [32, 48],
  iconAnchor: [16, 48],
  html: `
    <div style="
      position: relative;
      width: 32px;
      height: 48px;
      background-image: url('https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png');
      background-size: contain;
      background-repeat: no-repeat;
    ">
      <img src="${tafelIconUrl}" style="
        position: absolute;
        top: 4px;
        left: 2px;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        box-shadow: 0 0 4px rgba(0,0,0,0.4);
      " />
    </div>
  `,
});
